export default {"src":"/_next/static/media/download-icon.1556c3fd.svg","height":16,"width":16};